const namespaced = true;

const state = {
  itemScore: [],
  itemClass: [
    { value: 'XII IPA 2', text: 'XII IPA 2' },
    { value: 'XII IPS 2', text: 'XII IPS 2' }
  ],
  itemDatatype: [
    { value: 1, text: 'content.class_level' },
    { value: 2, text: 'menu.class' },
    { value: 3, text: 'form.course' }
  ],
  items: []
};

const getters = {
  itemClass: state => state.itemClass,
  itemScore: state => state.itemScore,
  itemDatatype: state => state.itemDatatype,
  items: state => state.items
};

const mutations = {
  SET_ITEM_SCORE: (state, payload) => {
    state.itemScore = payload;
  },
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  async fetchList({ commit, rootGetters }, payload) {
    try {
      const defaultPageable = rootGetters['table/defaultPageable'];
      const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
      const params = {
        size: payload.size,
        page: defaultPageable.currentPage - 1,
        search: payload.search,
        courseId: payload.courseId,
        classroomId: payload.classroomId,
        gradeId: payload.gradeId,
        sortBy
      };

      let url = `/api/report`;
      // if ((payload.status !== '' && typeof payload.status != 'undefined') || payload.role) {
      //   url;
      // }

      const {
        data: { data }
      } = await window.axios.get(url, { params });
      const { content, totalPages, totalElements } = data;

      commit('SET_ITEM', content);
      commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
      commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
    } catch (err) {
      throw err;
    }
  },
  fetchListScore: ({ commit }) => {
    const fakeData = [
      { no: 1, class: 'Class X', course: 'Biology', total_teacher: 10, total_student: 10, status: true },
      { no: 2, class: 'Class B', course: 'Biology', total_teacher: 20, total_student: 100, status: false },
      { no: 3, class: 'Class A', course: 'Biology', total_teacher: 10, total_student: 2, status: false },
      { no: 4, class: 'Class C', course: 'Biology', total_teacher: 2, total_student: 2, status: true }
    ];
    commit('SET_ITEM_SCORE', fakeData);
    return Promise.resolve();
  },

  // eslint-disable-next-line no-unused-vars
  async fetchCourse({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/course`);

      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchClassLevel({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/report/class-level-list`);

      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchClass({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/report/class-list`);

      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async export({ commit }) {
    return window.axios.get(`/api/report/export`, { responseType: 'arraybuffer' });
  }
};

export default { namespaced, state, getters, mutations, actions };
